module.exports = __webpack_public_path__ + "static/media/cynthia-lose.81875f95.png";